import React, { ReactNode } from 'react'
import clsx from 'clsx'

import styles from './_.module.css'

interface Props {
  children: string | ReactNode
  className?: string
}

const SolsticeCard: React.FC<Props> = ({ children, className }) => {
  return (
    <section className={clsx(className, styles.card)}>
      {children}

      <div className={styles.gradientContainer}>
        <div className={clsx(styles.gradient, styles.gradient__1)} />
        <div className={clsx(styles.gradient, styles.gradient__2)} />
      </div>
    </section>
  )
}
export default SolsticeCard
